/**
 * Patch shape adapters between the UI-kit's `Editable*Patch` types and the
 * contract `UpdateDraft*Request` shapes.
 *
 * Both sides now carry `EntityOrSuggestionRef` on the union slots (`assignedTo`,
 * `helpers.systems`, `task.successors.org-functions/systems`), so the adapters are
 * a near pass-through — a suggested orgFunction/system flows end to end as a
 * `{ type: 'suggestion', id }` ref and is resolved on approval.
 */
import type { EditableAssignmentPatch, EditableStepPatch } from '@bliks-io/ui';
import type { UpdateDraftAssignmentRequest, UpdateDraftStepRequest } from '@bliks-io/contracts';

// `helpers`, `assignedTo` and `task.successors` pass through unchanged — the
// UI-kit's patch types already carry the contract's own `StepHelpers` and
// union refs. `helpers` is destructured out and re-spread only so an
// explicitly `undefined` slot never reaches the wire as a key.
export function toUpdateDraftStepRequest(patch: EditableStepPatch): UpdateDraftStepRequest {
  const { helpers, ...rest } = patch;
  return {
    ...rest,
    ...(helpers !== undefined ? { helpers } : {})
  };
}

export function toUpdateDraftAssignmentRequest(
  patch: EditableAssignmentPatch
): UpdateDraftAssignmentRequest {
  const { helpers, ...rest } = patch;
  return {
    ...rest,
    ...(helpers !== undefined ? { helpers } : {})
  };
}
